
/**
 * Cache to register Holiday Types for the current user
 * @kind cache
 * @class Holiday Types
 * @description Custom lookup cache for Holiday Types
 * @usage let lookup = await Grape.cache.get('HolidayTypes');
 */
export default {
	name: 'HolidayTypes',
	options: {
		table: 'holiday_types',
		schema: 'public',
		limit: 100
	}
};
